import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, Glyphicon } from 'react-bootstrap'
import '../../Lock/css/lock.css'
import swal from 'sweetalert2'
import axios from 'axios'
import dayjs from 'dayjs'

import { useT } from '@transifex/react'
import { swalSuccess } from '../../../common/components/Swaler'
import UserLock from './UserLock'
import { removeLockAccesses } from '../../../common/redux/collectionActions'
import useSWR from '../../../hooks/useSWR'
import LockEvents from '../../Lock/components/LockEvents'

const UserItem = ({ customer, titleStyle, isMobile, newUserModalWithSubject, contactPersonLocks }) => {
  const t = useT()
  const dispatch = useDispatch()
  const { locks, admin } = useSelector((s) => s.collectionData)

  const [currentInflation, setCurrentInflation] = useState(null)
  const [smsInput, setSmsInput] = useState('')
  const [smsPageIndex, setSmsPageIndex] = useState(0)

  const { data: sms, mutate: mutateSms } = useSWR(currentInflation === 'sms' && `/subject/admin/s_sms/${customer._id}?page=${smsPageIndex}`)

  const userButtons = (e, str) => {
    e.preventDefault()
    if (currentInflation === str) return setCurrentInflation(null)

    setCurrentInflation(str)
  }

  const removeAllAccesses = (c) => {
    const username = c.surname ? `${c.name} ${c.surname}` : c.name || c.phone

    swal
      .fire({
        title: `<p>${t('Removing all accesses')}</p>`,
        type: 'warning',
        html: `<p>${t('Do you want to remove all accesses from {username}', { username })}</p>`,
        confirmButtonColor: '#006e78',
        confirmButtonText: t('Remove'),
        showCancelButton: true,
        cancelButtonText: t('Cancel'),
        onClick: setCurrentInflation(null),
      })
      .then((willSubmit) => {
        if (willSubmit.value !== true) return

        const accessIds = locks.reduce((acc, val) => {
          for (const user of val.users) {
            if (user.customer === c._id && user._id) acc.push(user._id)
          }

          return acc
        }, [])

        dispatch(removeLockAccesses(accessIds))
        swalSuccess(t('All accesses removed from {username}', { username }), null, 'Ok')
      })
  }

  const onSendSms = async () =>
    axios.post(`${window.MYQLOCX_API}/subject/admin/s_sms`, { customerId: customer._id, text: smsInput }).then(({ data }) => {
      mutateSms([{ _id: data._id, body: smsInput, consumed: new Date().toISOString() }, ...sms])
      setSmsInput('')
      swalSuccess(t('Text message sent!'), null, t('OK'))
    })

  const userLocks = locks.reduce((acc, lock) => {
    const access = lock.users.find((user) => user.customer === customer._id && !user.hasPendingAccessRequest)
    if (access) {
      acc.push(<UserLock t={t} customer={customer} key={lock._id} lock={lock} access={access} />)

      if (lock.carrier_door && (access.carrierDoorAccess || access.type === 'contactPerson')) {
        acc.push(<UserLock t={t} customer={customer} key={`${lock._id}-carrierDoor`} lock={{ ...lock, custom_name: `${lock.custom_name} (${t('carrier door')})`, isCarrierDoor: true }} access={access} />)
      }
    }
    return acc
  }, [])

  if (!userLocks.length) return null

  const inflate = (str) => {
    switch (str) {
      case 'sms':
        return sms || smsPageIndex > 0 ? (
          <div>
            {admin.user.roles?.includes('dataanalytics') && (
              <div>
                <hr />
                <input placeholder={t('Send text message here')} style={{ marginLeft: 60, border: 'none', borderBottom: '2px solid lightgrey', textAlign: 'center', width: '80%' }} value={smsInput} onChange={(e) => setSmsInput(e.target.value)} />
                <button style={{ background: '#006e78', borderRadius: 60, color: '#FFF', padding: 10 }} onClick={onSendSms}>
                  Skicka
                </button>
              </div>
            )}
            <br />
            <br />
            <div style={{ minHeight: 300 }}>
              {/* eslint-disable-next-line operator-linebreak */}
              {sms &&
                sms.map((s) => (
                  <center key={s._id}>
                    <div>{dayjs(s.consumed).format('D MMM YYYY HH:mm')}</div>
                    <div style={{ background: '#e0e0e0', padding: 3, width: '60%', borderRadius: 10 }}>{s.messageCreated || s.body}</div>
                    <br />
                  </center>
                ))}
            </div>
            <div>
              {smsPageIndex > 0 && (
                <button style={{ borderRadius: 10, color: '#FFF', background: '#006e78', marginLeft: 10, padding: 10 }} onClick={() => setSmsPageIndex(smsPageIndex - 1)}>
                  <Glyphicon glyph="glyphicon glyphicon-arrow-left" />
                  {t('Previous')}
                </button>
              )}
              {sms && sms.length === 10 && (
                <button style={{ borderRadius: 10, color: '#FFF', background: '#006e78', marginLeft: 10, padding: 10 }} onClick={() => setSmsPageIndex(smsPageIndex + 1)}>
                  {t('Next')}
                  <Glyphicon glyph="glyphicon glyphicon-arrow-right" />
                </button>
              )}
            </div>
          </div>
        ) : (
          t('Loading...')
        )

      case 'events':
        return <LockEvents customer={customer} />

      case 'access':
        return (
          <div>
            <br />
            <br />

            {userLocks.length && (
              <div onClick={() => removeAllAccesses(customer)} className="remove-user-door" style={{ textAlign: 'end', paddingRight: 80, cursor: 'pointer' }}>
                {t('Remove all')}
              </div>
            )}
            {userLocks.length ? userLocks : <div style={{ paddingBottom: '20px', textAlign: 'center', fontSize: 20, color: '#006e78' }}>{t('No accesses')}</div>}
          </div>
        )

      default:
        return null
    }
  }

  const isQlocxEmployee = customer.companyName?.includes('locx')

  const isContactPerson = contactPersonLocks && contactPersonLocks.length > 0
  return (
    <Row style={{ width: '100%', display: 'block', margin: 'auto' }} key={customer._id}>
      <div style={{ borderRadius: 20, marginBottom: '10px', width: '100%', paddingBottom: 10, background: isContactPerson ? 'transparent' : '' }} className="lock-list">
        <div className="lock-flex-container">
          <Col xs={12} sm={12} md={3}>
            <div>
              <p style={{ marginTop: 15 }} className="lock-label">
                <span style={titleStyle}>
                  {customer.name ? customer.name : <span style={{ fontWeight: '500' }}>{t('Phone:')}&nbsp;</span>} {customer.surname ? customer.surname : ''}
                </span>
                <span>{customer.companyName ? ` (${customer.companyName})` : ''}</span>
                {isContactPerson && !isQlocxEmployee && <span>&nbsp;{t('Administrator at {contactPersonLocks}', { contactPersonLocks })}</span>}
              </p>
              <p style={{ marginTop: -10, fontSize: '14px' }}>
                <span>{`${customer.phone || ''} ${customer.email || ''}`}</span>
              </p>
            </div>
          </Col>

          {customer.name && (
            <Col xs={4} sm={3} md={2}>
              <p
                onClick={(e) => userButtons(e, 'events')}
                style={{
                  minHeight: isMobile ? 60 : 0,
                  marginTop: isMobile ? 0 : 18,
                  border: currentInflation == 'events' ? 'none' : '',
                  color: currentInflation == 'events' ? '#006e78' : '',
                  backgroundColor: currentInflation == 'events' ? '#EDEEF1' : '',
                }}
                className="sub-title-text-container"
              >
                <span style={{ marginTop: isMobile ? 10 : 0 }}>{t('Events')}</span>
              </p>
            </Col>
          )}
          {admin.user.roles?.includes('dataanalytics') && (
            <Col xsHidden sm={3} md={2}>
              <p
                style={{
                  minHeight: isMobile ? 60 : 0,
                  marginTop: isMobile ? 0 : 18,
                  border: '',
                  color: '',
                  backgroundColor: '',
                }}
                className="sub-title-text-container"
                onClick={(e) => {
                  setSmsInput(customer.name ? '' : t("Don't forget to register in Qlocx app to get access to the delivery container."))
                  userButtons(e, 'sms')
                }}
              >
                <span style={{ marginTop: isMobile ? 10 : 0 }}>{t('Text messages')}</span>
              </p>
            </Col>
          )}
          <Col xs={customer.name ? 4 : 6} sm={3} md={2}>
            <p
              onClick={() => newUserModalWithSubject(customer)}
              style={{
                minHeight: isMobile ? 60 : 0,
                marginTop: isMobile ? 0 : 18,
              }}
              className="sub-title-text-container"
            >
              <span style={{ marginTop: isMobile ? 10 : 0 }}>{t('Manage roles')}</span>
            </p>
            {currentInflation == 'access' ? <span className="triangle-down"></span> : null}
          </Col>
          <Col xs={customer.name ? 4 : 6} sm={3} md={2}>
            <p
              onClick={(e) => userButtons(e, 'access')}
              style={{
                minHeight: isMobile ? 60 : 0,
                marginTop: isMobile ? 0 : 18,
                border: currentInflation == 'access' ? 'none' : '',
                color: currentInflation == 'access' ? '#006e78' : '',
                backgroundColor: currentInflation == 'access' ? '#EDEEF1' : '',
              }}
              className="sub-title-text-container"
            >
              <span style={{ marginTop: isMobile ? 10 : 0 }}>{t('Manage accesses')}</span>
            </p>
            {currentInflation == 'access' ? <span className="triangle-down"></span> : null}
          </Col>
        </div>
        {currentInflation && <div style={{ background: isContactPerson ? 'transparent' : '', padding: 10, paddingRight: 10 }}>{inflate(currentInflation)}</div>}
      </div>
    </Row>
  )
}

export default UserItem
